<div class="mi-mentor-container">
  <!-- Breadcrumb -->
  <div class="breadcrumb">
    <span class="breadcrumb-item">Inicio</span>
    <span class="breadcrumb-separator">></span>
    <span class="breadcrumb-item">Mi Mentor</span>
    <span class="breadcrumb-separator">></span>
    <span class="breadcrumb-item active">Agendar Cita</span>
  </div>

  <div class="header">
    <h1>Tu mentor asignado es {{ mentor?.coachProfileData?.firstName }} {{ mentor?.coachProfileData?.lastName }}</h1>
  </div>

  <!-- Botón de Debug para probar el modal
  <div class="debug-section">
    <button class="btn-debug" (click)="showDebugModal()">
      🐛 Debug: Ver Modal de Confirmación
    </button>
  </div> -->

  <div class="mentor-profile-card" *ngIf="mentor">
    <div class="mentor-header">
      <div class="mentor-photo">
        <img [src]="mentor.coachProfileData?.photo || 'assets/img/user-photo-default.png'" 
             [alt]="mentor.coachProfileData?.firstName"
             (error)="onPhotoError($event)">
      </div>
      
      <div class="mentor-content-wrapper">
        <div class="mentor-info">
          <h2>{{ mentor.coachProfileData?.firstName }} {{ mentor.coachProfileData?.lastName }}</h2>
          
          <div class="mentor-bio" *ngIf="mentor.coachProfileData?.ProfileData?.aboutMentor">
            <p style="text-align: justify;">{{ mentor.coachProfileData.ProfileData.aboutMentor }}</p>
          </div>
          
          <div class="about-linkedin" *ngIf="mentor.coachProfileData?.ProfileData?.contactLinks?.linkedin">
            <a [href]="mentor.coachProfileData.ProfileData.contactLinks.linkedin" target="_blank" class="linkedin-link-about">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>
          </div>
        </div>
        
        <div class="schedule-button">
          <button class="btn-schedule-main" (click)="scheduleAppointment()">
            Agendar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Detalles de la sesión como tarjeta separada -->
  <div class="session-details-card" *ngIf="mentor">
    <div class="session-details">
      <div class="detail-item">
        <span class="detail-label">SESIÓN</span>
        <span class="detail-value" *ngIf="!isPhoenixSessions">Individual</span>
        <span class="detail-value phoenix-sessions" *ngIf="isPhoenixSessions">Phoenix Sessions</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">TIPO</span>
        <span class="detail-value">Virtual</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">TIEMPO HASTA</span>
        <span class="detail-value" *ngIf="!isPhoenixSessions">60 min</span>
        <span class="detail-value phoenix-sessions" *ngIf="isPhoenixSessions">120 min (2 horas)</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">EXPERIENCIA</span>
        <span class="detail-value">+ {{ mentor?.coachProfileData?.ProfileData?.yearsOfExperience || '5' }} años</span>
      </div>
    </div>
  </div>

  <!-- Sección de agendamiento integrada en la página -->
  <div class="scheduling-section" *ngIf="mentor">
    <div class="scheduling-card">
      <div class="scheduling-header">
        <h3>Selecciona el día y la hora con tu mentor</h3>
      </div>

      <div class="scheduling-content">
        <!-- Calendario -->
        <div class="calendar-section">
          <div class="calendar-header">
            <button class="nav-button" type="button" 
                    (click)="previousMonth()" 
                    [disabled]="isPreviousMonthDisabled()">
              <i class="fas fa-chevron-left"></i>
            </button>
            <h4>{{ getMonthName(calendarDate) }} {{ getYear(calendarDate) }}</h4>
            <button class="nav-button" type="button" 
                    (click)="nextMonth()" 
                    [disabled]="isNextMonthDisabled()">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>

          <div class="calendar-grid">
            <!-- Días de la semana -->
            <div class="day-header" *ngFor="let day of [0,1,2,3,4,5,6]; let i = index">
              {{ getDayName(i) }}
            </div>

            <!-- Fechas -->
            <div 
              class="calendar-day" 
              *ngFor="let date of getCalendarDates(); let i = index"
              [class.today]="isToday(date)"
              [class.selected]="isSelectedDate(date)"
              [class.available]="isAvailableDate(date)"
              [class.unavailable]="!isAvailableDate(date)"
              (mousedown)="selectDate(date)"
              title="{{ date | date:'yyyy-MM-dd' }}">
              {{ date.getDate() }}
            </div>
          </div>
        </div>

        <!-- Selección de horarios -->
        <div class="time-section">
          <h4 *ngIf="!isPhoenixSessions">Elige tu horario</h4>
          <h4 *ngIf="isPhoenixSessions">Elige 2 horarios consecutivos (Phoenix Sessions - 2 horas)</h4>
          
          <!-- Información para Phoenix Sessions -->
          <div *ngIf="isPhoenixSessions" class="phoenix-sessions-info">
            <p class="info-text">
              <i class="fas fa-info-circle"></i>
              Selecciona 2 horarios consecutivos para tu sesión de Phoenix Sessions (2 horas total)
            </p>
            <div class="selected-times-info" *ngIf="selectedTimes.length > 0">
              <span class="selected-count">{{ selectedTimes.length }}/{{ maxAppointments }} horarios seleccionados</span>
            </div>
          </div>
          
          <div class="time-slots" *ngIf="availableSlots.length > 0">
            <button 
              *ngFor="let slot of availableSlots"
              class="time-slot"
              [class.selected]="isPhoenixSessions ? selectedTimes.includes(slot) : selectedTime === slot"
              [class.phoenix-selected]="isPhoenixSessions && selectedTimes.includes(slot)"
              (click)="selectTime(slot)">
              {{ slot }}
            </button>
          </div>
          <div class="no-slots-message" *ngIf="availableSlots.length === 0">
            <p>No hay horarios disponibles para esta fecha</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Botones de acción en la parte inferior -->
  <!-- <div class="action-buttons" *ngIf="mentor">
    <button class="btn-cancel" (click)="cancel()">
      Cancelar
    </button>
    <button class="btn-schedule" (click)="scheduleAppointment()">
      Agendar
    </button>
  </div> -->

  <div class="loading" *ngIf="loading">
    <p>Cargando información del mentor...</p>
  </div>

  <div class="no-mentor" *ngIf="!mentor && !loading">
    <p>No tienes un mentor asignado.</p>
  </div>

  <!-- Modal de confirmación de cita -->
  <div class="modal-overlay" *ngIf="showModal" (click)="closeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Confirmar Cita</h3>
        <button class="modal-close" (click)="closeModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      
      <div class="modal-body">
        <div class="appointment-summary">
          <div class="summary-item">
            <span class="label">Mentor:</span>
            <span class="value">{{ mentor?.coachProfileData?.firstName }} {{ mentor?.coachProfileData?.lastName }}</span>
          </div>
          
          <div class="summary-item">
            <span class="label">Fecha:</span>
            <span class="value">{{ selectedDate | date:'dd/MM/yyyy' }}</span>
          </div>
          
          <!-- Para Phoenix Sessions mostrar múltiples horarios -->
          <div class="summary-item" *ngIf="!isPhoenixSessions">
            <span class="label">Hora:</span>
            <span class="value">{{ selectedTime }}</span>
          </div>
          
          <div class="summary-item" *ngIf="isPhoenixSessions">
            <span class="label">Horarios:</span>
            <div class="phoenix-times">
              <span class="phoenix-time" *ngFor="let time of selectedTimes; let i = index">
                {{ time }}<span *ngIf="i < selectedTimes.length - 1">, </span>
              </span>
            </div>
          </div>
          
          <div class="summary-item">
            <span class="label">Tipo:</span>
            <span class="value" *ngIf="!isPhoenixSessions">Sesión Virtual</span>
            <span class="value phoenix-sessions" *ngIf="isPhoenixSessions">Phoenix Sessions</span>
          </div>
          
          <div class="summary-item">
            <span class="label">Duración:</span>
            <span class="value" *ngIf="!isPhoenixSessions">60 minutos</span>
            <span class="value phoenix-sessions" *ngIf="isPhoenixSessions">120 minutos (2 horas)</span>
          </div>
        </div>
        
        <div class="form-section">
          <h4>Información adicional</h4>
          
          <div class="form-group">
            <label for="notes">Notas (opcional):</label>
            <textarea 
              id="notes" 
              [(ngModel)]="appointmentNotes" 
              placeholder="Agrega cualquier información adicional o pregunta que tengas para tu mentor..."
              rows="3">
            </textarea>
          </div>
        </div>
      </div>
      
      <div class="modal-footer">
        <button class="btn-cancel" (click)="closeModal()">
          Cancelar
        </button>
        <button class="btn-confirm" (click)="confirmAppointment()" 
                [disabled]="!selectedDate || (!isPhoenixSessions && !selectedTime) || (isPhoenixSessions && selectedTimes.length !== maxAppointments)">
          {{ isPhoenixSessions ? 'Confirmar Phoenix Sessions' : 'Confirmar Cita' }}
        </button>
      </div>
    </div>
  </div>
</div>